import styled from "styled-components";
import { colors } from "@/theme";

export const ProductCartSubtotalsContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${colors.gray95};
  background-blend-mode: multiply;
`;

export const ProductCartSubtotalsHeaderSubtotals = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ProductCartSubtotalsHeaderCoopTotal = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ProductCartSubtotalsHeaderBalance = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: right;
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ProductCartSubtotalsValueSubtotals = styled.div`
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductCartSubtotalsValueCoopAmt = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductCartSubtotalsValueBalance = styled.div`
  color: ${colors.black};
  text-align: right;
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
